import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
	apiKey: "AIzaSyDVSjRdIcBI2QrlWJa7M8oyheiJc8Kh5Ec",
	authDomain: "amentibus-cultui.firebaseapp.com",
	projectId: "amentibus-cultui",
	storageBucket: "amentibus-cultui.appspot.com",
	messagingSenderId: "875273080246",
	appId: "1:875273080246:web:c203263f3f845368f24517",
	measurementId: "G-CX8SVH8NP4",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
